import React from 'react';
import { Button, Form, FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import { interestValidations } from 'form-validations';
import { connect } from 'react-redux';
import { CampaignAction } from 'redux/actions';


const AddInterestForm = (props) => {

    let [values, setValues] = React.useState({});
    let [errors, setErrors] = React.useState({});
    let [isSubmitted, setIsSubmitted] = React.useState(false);
    let [isValid, setIsValid] = React.useState(true);

    React.useEffect(() => {
        const obj = { id: props.selectedInterest[0], name: props.selectedInterest[1]};
        setValues(obj)
    }, [props.selectedCharge]);

    React.useEffect(() => {
        const validationErrors = interestValidations(values);
        isValid = Object.keys(validationErrors).length === 0;
        setIsValid(isValid);
        setErrors(validationErrors);
    }, [values]);

    const handleChange = (event) => {
        setValues({
            ...values, [event.target.name]: event.target.value
        })
    };

    const handleSubmit = () => {
        setIsSubmitted(true);
        if (isValid) {
            console.log('values: ', values)
            props.saveInterest(values);
        }
    }

    /*React.useEffect(() => {
        setIsSubmitted(false);
    }, [groupAdded]);*/

    return (
        <div>
            <Form>
                <FormGroup>
                    <Label for={'name'}>{'Name'}</Label>
                    <Input
                        type="text"
                        name="name"
                        id="name"
                        onChange={handleChange}
                        autoComplete={'off'}
                        value={(values && values.name) ? values.name : ''}
                    />
                    {(isSubmitted && errors.name && !values.name) && <FormFeedback >{errors.name} </FormFeedback>}
                </FormGroup>

                <Button
                    size="sm"
                    color="primary"
                    className="border-0"
                    block
                    onClick={handleSubmit} >
                    {props.selectedInterest && props.selectedInterest[0] ? 'Edit Interest' : 'Add Interest'}
                </Button>
            </Form>
        </div>
    );
};

const mapStateToProps = (state) => ({
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    interestSaved: (state.campaign && state.campaign.interestSaved) ? state.campaign.interestSaved : null,
})

const mapDispatchToProps = (dispatch) => ({
    saveInterest: (payload) => dispatch(CampaignAction.saveInterest(payload))
})



export default connect(mapStateToProps, mapDispatchToProps)(AddInterestForm);